import React from 'react';
import SharedNotificationsWidget from './SharedNotificationsWidget';

const All = () => (
  <SharedNotificationsWidget
    friendlyCollectionName="notifications"
    fetchNotificationsUrl="/agent_portal/api/passive_app_notifications/all"
    refreshOnDismissAll={false}
  />
);

export default All;
